import { POKEMON_STATS } from '../enums';

export const STAT_MAP = {
  hp: POKEMON_STATS.HP,
  attack: POKEMON_STATS.ATTACK,
  defense: POKEMON_STATS.DEFENSE,
  'special-attack': POKEMON_STATS.SPECIAL_ATTACK,
  'special-defense': POKEMON_STATS.SPECIAL_DEFENSE,
  speed: POKEMON_STATS.SPEED,
};
